// react library imports
import { useDispatch } from "react-redux";
import { Pencil, Trash } from "phosphor-react";

// import from hoc
import DropDown from "Hoc/DropDown";

const Popup = ({openDeletePopup, openEditPopup, name, edit, remove, close}) => {
    // define dispatch action
    const dispatch = useDispatch()

    // handle edit 
    const handleEdit = () =>{
      if (openEditPopup) {
        dispatch(openEditPopup())
      }else{
        edit()
      }
    }
    // handle delete 
    const handleDelete = () =>{
      if (openDeletePopup) {
        dispatch(openDeletePopup())
      }else{
        remove()
      }
    }
  return (
    <DropDown close={close}>
        <div className='mues_row_flex item_card_popup_item mues_column_gap_4 
        mues_blue mues_pointer' onClick={handleEdit}>
          <Pencil className='mues_wrapper_icon' weight='fill'/>
          <p className='mues_font_weight_500'>Edit {name}</p>
        </div>
        <div className='mues_row_flex item_card_popup_item mues_column_gap_4 
        mues_red mues_pointer' onClick={handleDelete}>
          <Trash className='mues_wrapper_icon' weight='fill'/>
          <p className='mues_font_weight_500'>Delete {name}</p>
        </div>
    </DropDown>
  )
}

export default Popup